import {useInjex} from '@injex/react-plugin';
import {HistoryReportsColumnsManager} from "../../managers/historyReportsColumnsManager.mdl";

export default function useHistoryReportsColumnsManager(): HistoryReportsColumnsManager {
    const [inject] = useInjex();
    return inject<HistoryReportsColumnsManager>('historyReportsColumnsManager');
}
